import React, { lazy } from "react";
import { Navbar, Nav, Button, Whisper, Tooltip } from "rsuite";
import {
  getUserProfile,
  getUserType,
  hideForMobileAppWebView,
} from "../utils/helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRightFromBracket,
  faBars,
  faPhone,
  faClock,
} from "@fortawesome/free-solid-svg-icons";
import { Logout } from "../auth/auth";
import { faViber, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import ChangePassword from "../auth/changePassword";
import { useNavigate } from "react-router-dom";

const LeftSideBar = lazy(() => import("./asideNavBar"));

export default function DashboardLayout({ children }) {
  const navigate = useNavigate();
  const activeSlideMenu = () => {
    var menu = document.querySelector(".left-sidebar.shadow");
    menu.classList.toggle("active");
    var backdrop = document.querySelector(".cm-backdrop-wrapper");
    backdrop.classList.toggle("show");
  };

  return (
    <React.Fragment>
      <div className="">
        <LeftSideBar />
        <div className="main-body">
          {hideForMobileAppWebView() && (
            <Navbar className="shadow bg-white rounded-md mx-5">
              <Button
                className="lg:hidden"
                appearance="subtle"
                active
                style={{ marginTop: "12px", marginLeft: "12px" }}
                onClick={() => activeSlideMenu()}
              >
                <FontAwesomeIcon icon={faBars} />
              </Button>
              <Nav pullRight>
                <Nav.Menu
                  title={
                    getUserProfile().AgentCode
                      ? getUserProfile().FullName +
                        " (" +
                        getUserProfile().AgentCode +
                        ")"
                      : `${getUserProfile().FullName} (Customer)`
                  }
                  className="w-full"
                >
                  <Nav.Item onClick={() => navigate("/change-password")}>
                    <FontAwesomeIcon
                      icon={faRightFromBracket}
                      className="me-3"
                    />
                    Change Password
                  </Nav.Item>
                  <Nav.Item onClick={() => Logout()}>
                    <FontAwesomeIcon
                      icon={faRightFromBracket}
                      className="me-3"
                    />
                    Logout
                  </Nav.Item>
                </Nav.Menu>
              </Nav>
            </Navbar>
          )}
          <div className="p-5">
            <div className="main-app">{children}</div>
            <div className="hidden lg:flex justify-between align-center text-sm text-gray-600 mt-10">
              <span className="text-xs">2024© IME Life Insurance</span>
              <div className="flex justify-center font-semibold gap-4 flex">
                Contact us:
                <Whisper
                  placement="top"
                  controlId="control-id-hover"
                  trigger="hover"
                  speaker={<Tooltip>call us</Tooltip>}
                >
                  <span className="cursor-help">
                    <FontAwesomeIcon icon={faPhone} /> 01-4024071
                  </span>
                </Whisper>
                |
                <Whisper
                  placement="top"
                  controlId="control-id-hover"
                  trigger="hover"
                  speaker={<Tooltip>call us</Tooltip>}
                >
                  <span className="cursor-help">01-5971433</span>
                </Whisper>
              </div>
            </div>
          </div>
        </div>
        <div
          className="cm-backdrop-wrapper"
          onClick={() => activeSlideMenu()}
        ></div>
        {/* <RightSideBar /> */}
      </div>
    </React.Fragment>
  );
}
